'use strict';

/**
 * Component for the object history
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../../templates/components/detail/field-history.hbs');

var HistoryComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        recentHistory: function() {
            return this.model.getRecentHistoryEntry();
        },
    },

    hasValue: function() {
        return this.model.getRecentHistoryEntry() ? true : false;
    },
});

module.exports = HistoryComponent;